import { DiagnosticItem, DiagnosticItemName } from "@core/types";

export const ITEM_NAME_MAP: DiagnosticItem = {
    [DiagnosticItemName.ETHERNAT_LAN_CONNECTION] : "Testing Ethernet LAN Connection",
    [DiagnosticItemName.PING_PRIMARY_DNS] : "Ping Primary DNS",
    [DiagnosticItemName.PING_YAHOO] : "Ping www.google.com",
    [DiagnosticItemName.PING_OTHERS] : "Ping other IP Address",
}